import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { MsalProvider } from '@azure/msal-react';
import { EventType } from '@azure/msal-browser';
import { App } from './App';
import { AuthProvider } from './auth/AuthProvider';
import { msalInstance } from './auth/msalConfig';
import './index.css';

// Prevent scroll-wheel over a focused number input from silently changing its
// value (a common source of accidental edits, e.g. 1000 -> 999.97). Blurring
// lets the page scroll instead of incrementing the field.
document.addEventListener('wheel', (e) => {
  const el = e.target as HTMLElement;
  if (el instanceof HTMLInputElement && el.type === 'number' && el === document.activeElement) {
    el.blur();
  }
}, { passive: true });

await msalInstance.initialize();

// Track the active account so token acquisition has something to bind to.
const accounts = msalInstance.getAllAccounts();
if (accounts.length > 0) msalInstance.setActiveAccount(accounts[0]);

msalInstance.addEventCallback(event => {
  if (
    (event.eventType === EventType.LOGIN_SUCCESS ||
      event.eventType === EventType.ACQUIRE_TOKEN_SUCCESS) &&
    event.payload &&
    'account' in event.payload &&
    event.payload.account
  ) {
    msalInstance.setActiveAccount(event.payload.account);
  }
});

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <MsalProvider instance={msalInstance}>
      <AuthProvider>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </AuthProvider>
    </MsalProvider>
  </React.StrictMode>,
);
